// src/components/MobileHeader.jsx
import React from 'react';
import useModal from '../hooks/useModal';
import LoginForm from './LoginForm';
import SignupForm from './SignupForm';
import Modal from './Modal';
import "styles/Header.css";

export default function MobileHeader() {
  const login = useModal();
  const signup = useModal();

  return (
    <div data-cy="mobile-header" className="is-hidden-tablet homepage" data-v-628b53e2="">
      <div className="mobile-top-placeholder" data-v-628b53e2="" />
      <div data-cy="mobile-top" className="mobile-top" data-v-628b53e2="">
        <a
          href="/"
          aria-current="page"
          className="logo-link nuxt-link-exact-active nuxt-link-active"
          data-v-628b53e2=""
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c"
            alt="ft"
            className="logo"
            data-v-628b53e2=""
            width="55"
            height="50"
          />
        </a>

        <div className="mobile-top-right" data-v-628b53e2="">
          <button
            id="login-mobile-button"
            className="button grey is-shadowless login-button header-right-item is-rounded login-mobile-button"
            data-v-628b53e2=""
            onClick={login.openModal}
          >
            <span>Log in</span>
          </button>

          <button
            id="signup-mobile-button"
            className="button primary has-soft-shadow login-button header-right-item signup_btn is-rounded signup-mobile-button"
            data-v-628b53e2=""
            onClick={signup.openModal}
          >
            <span>Sign up</span>
          </button>

          <div data-v-2a9ca575="" data-v-628b53e2="">
            <div
              data-cy="mobile-sidebar-opener"
              aria-label="layout.buttons.sidebar"
              className="mobile-sidebar-opener"
              data-v-2a9ca575=""
            >
              <span
                role="button"
                aria-label="layout.buttons.logged_out_icon"
                className="icon mobile-sidebar-opener-icon is-medium"
                style={{ fontSize: '32px' }}
                data-v-563d9226=""
                data-v-2a9ca575=""
              >
                <svg viewBox="0 0 24 24" data-v-563d9226="">
                  <path
                    d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z"
                  />
                </svg>
              </span>
              <div className="mobile-sidebar-icon" data-v-2a9ca575="">
                <div data-v-2a9ca575=""></div>
                <div data-v-2a9ca575=""></div>
                <div data-v-2a9ca575=""></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modals replace the old inline pop-ups */}
      <Modal isOpen={login.isOpen} onClose={login.closeModal}>
        <LoginForm onSuccess={login.closeModal} />
      </Modal>
      <Modal isOpen={signup.isOpen} onClose={signup.closeModal}>
        <SignupForm onSuccess={signup.closeModal} />
      </Modal>
    </div>
  );
}